<template>
  <div class="upload-form">
    <el-upload
      action=""
      multiple
      accept="image/*"
      name="image"
      :data="requestData"
      :file-list="initialFileList"
      :on-remove="onFileRemove"
      :on-exceed="handleExceed"
      :before-upload="handleSizeExceed"
      :http-request="handleUploadImage"
      :limit="5"
    >
      <el-button class="light-gray">
        이미지 업로드
      </el-button>
      <div
        slot="tip"
        class="el-upload__tip"
      >
        첨부하실 이미지를 선택해주세요. (jpg , png 지원 / 최대 3MB / 최대 5개)
      </div>
    </el-upload>
  </div>
</template>

<script>
  import { fiflboxApi } from '@/utils/api';

  export default {
    name: "ImageUploadField",
    props: {
      'usage': {
        type: Number,
      },
      'value': {
        type: Array
      },
      'initialFileList': {
        type: Array
      }
    },
    computed: {
      requestData() {
        return {
          usage: this.usage
        }
      }
    },
    methods: {
      async handleUploadImage({ file }) {
        const formData = new FormData();

        formData.append("image", file);
        formData.append("usage", 1);
        
        const { data } = await fiflboxApi.v2.postAccountImages(formData);

        this.$emit('input', [...this.value, data.id]);
      },
      handleSizeExceed(file) {
        if (file.size < 3 * 1024 * 1024) {
          return true;
        }

        this.$message.warning(`3MB 이하 이미지 파일만 업로드 가능합니다.`);
        return false;
      },
      handleExceed(files, fileList) {
        this.$message.warning(`최대 5개까지 업로드 가능합니다.`);
      },
      onFileRemove(file, fileList) {
        const images = this.value.filter(image => image !== file.id)
        this.$emit('input', images)
      },
    }
  }
</script>
